import { render, staticRenderFns } from "./ad-copy.vue?vue&type=template&id=67b9a2c0&scoped=true"
import script from "./ad-copy.vue?vue&type=script&lang=js"
export * from "./ad-copy.vue?vue&type=script&lang=js"
import style0 from "./ad-copy.vue?vue&type=style&index=0&id=67b9a2c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b9a2c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1154244279/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67b9a2c0')) {
      api.createRecord('67b9a2c0', component.options)
    } else {
      api.reload('67b9a2c0', component.options)
    }
    module.hot.accept("./ad-copy.vue?vue&type=template&id=67b9a2c0&scoped=true", function () {
      api.rerender('67b9a2c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/ad-copy.vue"
export default component.exports